import React from 'react';
import classNames from 'classnames';
// import { Link } from 'react-router-dom';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <a href="mailto:digitalterna@gmail.com">digitalterna@gmail.com</a>
        </li>
        <li>
          <a href='https://wa.me/+573104356629'><WhatsAppIcon /></a>
        </li>
        {/* <li>
          <Link to="#0">About us</Link>
        </li>
        <li>
          <Link to="#0">FAQ's</Link>
        </li>
        <li>
          <Link to="#0">Support</Link>
        </li> */}
      </ul>
    </nav>
  );
}

export default FooterNav;